import { render, staticRenderFns } from "./PlanHint.vue?vue&type=template&id=bc481972&scoped=true&"
import script from "./PlanHint.vue?vue&type=script&lang=js&"
export * from "./PlanHint.vue?vue&type=script&lang=js&"
import style0 from "./PlanHint.vue?vue&type=style&index=0&id=bc481972&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc481972",
  null
  
)

export default component.exports